import { AnimatePresence, motion } from "framer-motion"
import { useEffect, useRef, useState } from "react"

const WORDS = ["Inspire", "Build", "Iterate", "Innovation"]
const EASE = [0.4, 0, 0.2, 1]
const TOTAL_MS = 2700

export default function LoadingScreen({ onComplete }) {
  const [wordIndex, setWordIndex] = useState(0)
  const [progress, setProgress] = useState(0)
  const onCompleteRef = useRef(onComplete)
  const completedRef = useRef(false)

  useEffect(() => {
    onCompleteRef.current = onComplete
  }, [onComplete])

  useEffect(() => {
    const intervalId = window.setInterval(() => {
      setWordIndex((prev) => {
        if (prev >= WORDS.length - 1) {
          window.clearInterval(intervalId)
          return prev
        }
        return prev + 1
      })
    }, 900)

    return () => window.clearInterval(intervalId)
  }, [])

  useEffect(() => {
    const start = performance.now()
    let rafId = 0
    let completeTimeoutId = 0

    const tick = (now) => {
      const elapsed = now - start
      const nextProgress = Math.min((elapsed / TOTAL_MS) * 100, 100)
      setProgress(nextProgress)

      if (nextProgress >= 100) {
        if (!completedRef.current) {
          completedRef.current = true
          completeTimeoutId = window.setTimeout(() => {
            onCompleteRef.current()
          }, 400)
        }
        return
      }

      rafId = window.requestAnimationFrame(tick)
    }

    rafId = window.requestAnimationFrame(tick)

    return () => {
      window.cancelAnimationFrame(rafId)
      window.clearTimeout(completeTimeoutId)
    }
  }, [])

  return (
    <motion.div
      className="loading-screen"
      exit={{ opacity: 0 }}
      transition={{ duration: 0.6, ease: EASE }}
    >
      <motion.div
        className="loading-screen-label"
        initial={{ opacity: 0, y: -20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6, delay: 0.1, ease: EASE }}
      >
        RICE PORTFOLIO
      </motion.div>

      <div className="loading-screen-center">
        <AnimatePresence mode="wait">
          <motion.span
            key={wordIndex}
            className="loading-screen-word"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -20 }}
            transition={{ duration: 0.4, ease: EASE }}
          >
            {WORDS[wordIndex]}
          </motion.span>
        </AnimatePresence>
      </div>

      <motion.div
        className="loading-screen-counter"
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6, delay: 0.1, ease: EASE }}
      >
        {Math.round(progress).toString().padStart(3, "0")}
      </motion.div>

      <div className="loading-screen-track">
        <motion.div
          className="loading-screen-fill"
          initial={{ scaleX: 0 }}
          animate={{ scaleX: progress / 100 }}
          transition={{ duration: 0.1, ease: "linear" }}
        />
      </div>
    </motion.div>
  )
}
